// extracted by mini-css-extract-plugin
export var createdDate = "_nt-1";
export var divider = "_nt-2";
export var headerDivider = "_nt-3";
export var messagesCard = "_nt-0";
export var messagesContainer = "_nt-6";
export var messagesContainerWrapper = "_nt-4";
export var showLeftPanelButton = "_nt-8";
export var topButtons = "_nt-7";
export var withPadding = "_nt-5";